import { AssetData, ContactPersonBlockData } from "@/storyblok/schemas";
import { makeEditable } from "@/storyblok/visual-editor";
import { renderRichText } from "@storyblok/js";
import IconEmail from "../icons/IconEmail";
import IconPhone from "../icons/IconPhone";
import VideoLightbox from "../media/VideoLightbox";
import { resolveImageUrl, resolveSectionClasses } from "@/storyblok/resolvers";
import StickyOnScroll from "../interactivity/StickyOnScroll";

export default function ContactPerson({
  data,
}: {
  data: ContactPersonBlockData;
}) {
  return (
    <StickyOnScroll>
      <section
        id={data.anchor}
        className={resolveSectionClasses(
          data,
          "container section--contact-person"
        )}
        {...makeEditable(data)}
        style={{
          "--color-background": data.background_color?.color,
        }}
      >
        {data.video_poster?.filename && (
          <div className="col video">
            <VideoLightbox
              src={data.video?.filename}
              poster={resolveImageUrl(data.video_poster as AssetData, {
                width: 450,
              })}
              alt={data.video_poster.alt}
            />
          </div>
        )}
        <div className="col">
          <h3>{data.title}</h3>
          {data.avatar && (
            <img
              src={resolveImageUrl(data.avatar, { width: 50 })}
              alt={data.avatar.alt}
              className="avatar"
            />
          )}
          <div
            dangerouslySetInnerHTML={{ __html: renderRichText(data.content) }}
          ></div>
        </div>
        <div className="col">
          <ul>
            {data.email && (
              <li>
                <a href={`mailto:${data.email}`}>
                  <IconEmail />
                  <span>E-mail</span>
                </a>
              </li>
            )}
            {data.phone && (
              <li>
                <a href={`tel:${data.phone}`}>
                  <IconPhone />
                  <span>{data.phone}</span>
                </a>
              </li>
            )}
            {data.whatsapp && (
              <li>
                <a href={data.whatsapp}>
                  <img
                    src="/assets/images/ico_whatsapp.svg"
                    alt="WhatsApp Icon"
                  />
                  <span>WhatsApp</span>
                </a>
              </li>
            )}
          </ul>
        </div>
      </section>
    </StickyOnScroll>
  );
}
